module.exports = "<div class=\"ubg-right-column ubg-layout-column\" #rightColumn [style.paddingTop.px]=\"pTop\">\n  <ng-content></ng-content>\n</div>"